import * as React from "react";
import { useTranslation } from "react-i18next";
import NewFormField from "../../../../../common/layout/form/NewFormField";
import {
    container,
    divider,
    fieldContainer,
} from "../../../../styles/fieldsContainer.styles";

interface ICompanyFieldsProps {
    requireCompanyData?: boolean;
    isPolishCompany: boolean
}

const CompanyFields: React.FC<ICompanyFieldsProps> = ({ requireCompanyData, isPolishCompany }) => {
    const { t } = useTranslation("admin");
    return (
        <div className={container}>
            <NewFormField name="name" label={t("auth.formLabels.companyName") as string} required={requireCompanyData && isPolishCompany} />
            <div className={divider}>
                <div className={fieldContainer}>
                    <NewFormField name="taxNumber" label={t("auth.formLabels.nip") as string} required={requireCompanyData && isPolishCompany} />
                </div>
                <div className={fieldContainer}>
                    <NewFormField name="bdo" label={t("auth.formLabels.bdo") as string} required={false} />
                </div>
            </div>
            <div className={fieldContainer}>
                <NewFormField name="regon" label={t("auth.formLabels.regon") as string} required={requireCompanyData && isPolishCompany} />
            </div>
        </div>
    );
};

export default CompanyFields;